import { ReactNode } from "react";
import { RowCenter } from "style/preset"
import styled from "styled-components"
import CImage from "./CImage";

interface Props {
    imgUrl: string;
    width?: string;
    height?: string;
    children?: ReactNode;
}

const ImgCom = ({ imgUrl, width = '26px', height = '26px', children = <></>} : Props) => {
    return <ImgOutWrap>
        <ImgInWrap>
            {
              imgUrl && <CImage width={width} height={height} src={imgUrl}></CImage>
            }
            {
              !imgUrl && children
            }
        </ImgInWrap>
    </ImgOutWrap>
}

export const ImgOutWrap = styled(RowCenter)`
    width: 48px;
    height: 48px;
    background-color: #F4F5F5;
    border-radius: 50%;
`

const ImgInWrap = styled(RowCenter)`
    width: 36px;
    height: 36px;
    background-color: ${({theme}) => theme.basicWhite};
    border-radius: 50%;
`

// eslint-disable-next-line no-lone-blocks
{/* <ImgWrap width={width} height={width} src={imgUrl}></ImgWrap> */}
export const ImgWrap = styled.img<{width: string, height: string;}>`
    width: ${({width}) => width};
    height: ${({height}) => height};
    border-radius: 50%;
`

export default ImgCom